import styled, { css } from 'styled-components';

export const ToggleWrapper = styled.div`
  padding: 8px 10px;
  display: flex;
  align-items: center;
  position: relative;
  label {
    cursor: pointer;
  }
  ${(props) =>
    props.$loading &&
    css`
      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999;
        width: 100%;
        height: 100%;
        background: rgba(14, 21, 24, 0.72) url('/images/loader2.svg') no-repeat 50% 50%;
        background-size: 20px auto;
        border-radius: 8px;
      }
    `}
`;

export const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;

  &:checked + span {
    background-color: #47b972;
  }
  &:checked + span:before {
    transform: translateX(18px);
  }
`;

export const Slider = styled.span`
  position: relative;
  width: 40px;
  height: 22px;
  display: inline-block;
  background: #3d4952;
  border-radius: 22px;
  margin-right: 12px;
  vertical-align: middle;
  transition: background 0.3s;
  &:before {
    position: absolute;
    content: '';
    height: 18px;
    width: 18px;
    left: 2px;
    top: 2px;
    background: #fff;
    border-radius: 50%;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
    transition: 0.3s;
  }
`;
